

















































import Vue from 'vue'
import uniqBy from 'lodash/uniqBy'
import ButtonShareProduct from '@/product/components/ButtonShareProduct.vue'
import Loading from '@/common/components/Loading.vue'
import BaseImage from '@/common/components/BaseImage.vue'
import ProductImagesCarousel from '@/product/components/productSlider/ProductImagesCarousel.vue'
import { EVENT_LABELS } from '@/common/utils'
import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES } from '@/common/constants'
import {
  ProductSkuImage,
  ProductState
} from '@/product/types'
import { PRODUCT_IMAGE_TYPES } from '@/product/const'
import { format2DigitsNumber } from '@/common/utils/common'

export default Vue.extend({
  components: {
    ButtonShareProduct,
    Loading,
    ProductImagesCarousel,
    BaseImage
  },
  props: {
    isMobileView: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    currentImageIndex: number
    selectedImageView?: ProductSkuImage
  } {
    return {
      currentImageIndex: 0,
      selectedImageView: undefined
    }
  },
  computed: {
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    },
    productName(): string {
      return this.$store.state.productDetail.product.displayName
    },
    currentSkuId(): string {
      return (this.$store.state as ProductState).productDetail.sku.id
    },
    imageLoading(): boolean {
      return this.$store.getters.imageLoading
    },
    imgPlaceholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    productImagesOrder(): Record<string, number> {
      return {
        [PRODUCT_IMAGE_TYPES.PRODUCT]: 1,
        [PRODUCT_IMAGE_TYPES.WEARING]: 2,
        [PRODUCT_IMAGE_TYPES.FUNCTIONAL]: 3,
        [PRODUCT_IMAGE_TYPES.FABRIC]: 4,
        [PRODUCT_IMAGE_TYPES.EXPLANATION]: 5
      }
    },
    productImages(): ProductSkuImage[] {
      if (!this.$store.getters.skuImages) return []
      return [...this.$store.getters.skuImages].sort((img1: ProductSkuImage, img2: ProductSkuImage) => {
        return this.productImagesOrder[img1.imageType] >= this.productImagesOrder[img2.imageType] ? 1 : -1
      })
    },
    imageList(): ProductSkuImage[] {
      return uniqBy([...this.productImages], 'thumbnail')
    },
    currentImage(): ProductSkuImage | undefined {
      return this.imageList[this.currentImageIndex]
    },
    EVENT_LABELS(): string {
      return EVENT_LABELS.SHARE_IN_IMAGE
    },
    viewProgress(): string {
      return `${format2DigitsNumber(this.currentImageIndex + 1)} / ${
        format2DigitsNumber(this.imageList.length)
      }`
    }
  },
  watch: {
    currentSkuId() {
      this.currentImageIndex = 0
    }
  },
  methods: {
    onChangeImage(index: number) {
      this.currentImageIndex = index
    }
  }
})
